<script>
    import { beforeUpdate, createEventDispatcher, afterUpdate } from 'svelte';
    import { months } from '../months';
    import { getDateMin, getDay, getYearArray, getFullYear, getMonthNumber } from '../helpers/date';

    // Declare the dispatcher
    const dispatch = createEventDispatcher();

    //PROPS
    export let dayLabel = 'Day';
    export let monthLabel = 'Month';
    export let yearLabel = 'Year';
    export let i18n = 'en';

    //METHODS
    const changeDay = (value) => {
        dispatch('day', value);
    };

    const changeMonth = (value) => {
        dispatch('month', value);
    };

    const changeYear = (value) => {
        console.log('changeYear');
        console.log(value);
        dispatch('year', value);
    };

    const prependZero = (value) => {
        return '0' + (value + 1);
    };

    const optionValue = (value) => {
        return value + 1 < 10 ? prependZero(value) : value + 1;
    };

    // INIT OF THE COMPONENT
    const dateMin = getDateMin();
    const yearArray = getYearArray(dateMin);
    export let day = getDay(dateMin);
    export let month = getMonthNumber(dateMin);
    export let year = getFullYear(dateMin);

    afterUpdate(() => {
        document.getElementById('year').value = year;
        document.getElementById('month').value = month;
        document.getElementById('day').value = day;
    });
</script>

<!-- ======================== HTML TEMPLATE ================================= -->
<div class="app-msi_flex-column app-msi_align-items-center">
    <div class="app-msi_form-row">
        <div class="app-msi_flex-auto">
            <label for="day">{dayLabel}</label>
            <select
                class="app-msi_form-control"
                on:change={(event) => {
                    changeDay(event.target.value);
                }}
                value={day}
                id="day"
            >
                {#each Array(31) as _, i}
                    <option value={optionValue(i)}>{i + 1}</option>
                {/each}
            </select>
        </div>
        <div class="app-msi_flex-auto">
            <label for="month">{monthLabel}</label>
            <select
                class="app-msi_form-control"
                on:change={(event) => {
                    changeMonth(event.target.value);
                }}
                value={month}
                id="month"
            >
                {#each months[i18n] as month, i}
                    <option value={optionValue(i)}>{month}</option>
                {/each}
            </select>
        </div>
        <div class="app-msi_flex-auto">
            <label for="year">{yearLabel}</label>
            <select
                class="app-msi_form-control"
                on:change={(event) => {
                    changeYear(event.target.value);
                }}
                value={year}
                id="year"
            >
                {#each yearArray as _, i}
                    <option value={yearArray[i]}>{yearArray[i]}</option>
                {/each}
            </select>
        </div>
    </div>
</div>
